export const environment = {
  production: false,
  hmr: true,
  application: {
    name: 'BizChargeSystem',
    logoUrl: '',
  },
  oAuthConfig: {
    // 其他环境
    issuer: 'http://id4.yuncloudtech.cn',
    // issuer: 'http://192.168.3.147:44362',

    // KPI测试环境
    // issuer: 'http://81.68.221.56:44312',  // 1/13作废
    // issuer: 'http://81.68.221.56:44363',

    clientId: 'BizChargeSystem_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'BizChargeSystem WechatService FileService MessageService offline_access WorkflowService MobileReadService KPIService ChargeWechatService IotConMeterReadingService CallService',
    showDebugInformation: true,
    oidc: false,
    requireHttps: false,
  },
  apis: {
    default: {
      // 成都测试环境
      // url: 'http://81.68.221.56:44311',   // 1/13 作废
      // url: 'http://81.68.221.56:44321',
      // approvalUrl: 'http://cdxj-workflow.yuncloudtech.cn',
      // uploadUrl: 'http://81.68.221.56:44368',

      url: 'http://chargesystem.yuncloudtech.cn',
      // url: 'http://192.168.3.147:44318',
      approvalUrl: 'http://charge-workflow.yuncloudtech.cn',
      uploadUrl: 'http://fileservice.yuncloudtech.cn',
      signalRUrl: 'http://81.68.221.56:8088',
      flowUrl: 'http://openauth.yuncloudtech.cn',
      messageServiceUrl: 'http://messageservice.yuncloudtech.cn',
      // kpiUrl: 'http://81.68.221.56:9092',
      kpiUrl: 'http://81.68.221.56:9093',
      pdaUrl: 'http://mobilereadtransfer.yuncloudtech.cn',
      openWorkUrl: 'http://charge-worker.yuncloudtech.cn',
    },
  },
  tencentBucket: {
    defaultBucket: 'shyuntechtest',
    defaultAppID: '1259078701',
    systemLogoBucket: 'publicbuckettest',
  },
  lodopLicenses: {
    key: 'AE6B22250053DEEB39CDA3788734525E667'
  },
  localization: {
    defaultResourceName: 'BizChargeSystem',
  },
  footer: `@2020 上海沄远科技有限公司 版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" href="https://beian.miit.gov.cn">沪ICP备2020030299号-3</a>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005306">
            <img src="../../../assets/images/police.png" alt="">沪公网安备 31011002005385号</a>`,
  loginFooter: `<div *ngIf="isShowFooter" class="login-footer">
        <p>@2020 上海沄远科技有限公司 版权所有</p>
        <p><a target="_blank" href="https://beian.miit.gov.cn">沪ICP备2020030299号-3</a></p>
        <p><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011002005306">
          <img src="../../../assets/images/police.png" alt="">沪公网安备 31011002005385号</a></p>
      </div>`,
  webTitle: '沄远科技',
  mustInputTenant: false,
  canWeChatLogin: true,
  loginLogo: 'login-logo.png',
  favicon: 'favicon.ico',
};
// 微信小程序的api地址
export const wechatEnvironment = {
  production: false,
  application: {
    name: 'WechatService',
    logoUrl: '',
  },
  // oAuthConfig: {
  //   issuer: 'http://81.68.221.56:44362',
  //   clientId: 'WechatService_App',
  //   dummyClientSecret: '1q2w3e*',
  //   scope: 'WechatService',
  //   showDebugInformation: true,
  //   oidc: false,
  //   requireHttps: false,
  // },
  apis: {
    default: {
      url: 'https://cloudwechattest.shyuntech.com',
    },
  },
  localization: {
    defaultResourceName: 'WechatService',
  },
};
